<template>
  <CContainer v-if="user">
    <CRow class="justify-content-center mt-5">
      <CCol md="5" class="text-center">
        <Avatar
          v-if="showPhoto && user.avatar"
          :user-role="userRole"
          :user="user"
        />
        <h2 class="mt-3" data-test-id="student-settings-name">
          {{ user.first_name + " " + user.last_name }}
        </h2>
        <p data-test-id="student-settings-email">{{ user.email }}</p>
        <div
          v-if="
            isActiveKioskModule &&
            !activeSchool.hide_student_kiosk_passcode_field
          "
          class="mt-2 mb-5"
        >
          <CAlert
            data-test-id="student-profile-alert"
            v-if="reqResponse.message"
            class="mt-4"
            :color="reqResponse.type"
            :show="!!reqResponse.message"
          >
            {{ reqResponse.message }}
          </CAlert>
          <h5 class="text-start">Kiosk passcode</h5>
          <div class="kiosk-input-group input-icon-field">
            <div class="form-group text-start">
              <input
                data-test-id="student-profile-input"
                v-model="form.password"
                :type="passwordSecure ? 'password' : 'text'"
                class="form-control pe-5"
                :class="{
                  'is-invalid':
                    v$.form.password.$error ||
                    reqResponse.errors['kiosk_passcode']
                }"
                placeholder="Password"
                @keyup.enter.prevent="submit"
              />
              <div
                v-if="v$.form.$error && v$.form.password.required.$invalid"
                data-test-id="student-profile-error"
                class="invalid-feedback"
              >
                This field is required
              </div>
              <div
                v-if="reqResponse.errors['kiosk_passcode']"
                class="invalid-feedback"
              >
                {{ reqResponse.errors["kiosk_passcode"][0] }}
              </div>
            </div>
            <span class="field-icon cursor-pointer" @click="togglePass">
              <i
                :class="
                  passwordSecure
                    ? 'fi flaticon-eye me-2'
                    : 'fi flaticon-hide me-2'
                "
              />
            </span>
          </div>

          <div v-if="form.errors" class="d-block invalid-feedback text-start">
            {{ form.errors }}
          </div>
          <div class="form-group form-actions mt-3">
            <div
              data-test-id="student-profile-submit"
              class="d-inline"
              @click="submit()"
            >
              <CLoadingButton
                :spinner="isLoading"
                :disabled="isLoading"
                :loading="isLoading"
                class="btn bg-gradient-blue text-white"
              >
                Submit
              </CLoadingButton>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import { required } from "vuelidate/lib/validators"
import Avatar from "./Avatar.vue"
import { mapGetters } from "vuex"

export default {
  name: "UserSettings",
  setup() {
    return { v$: useVuelidate() }
  },
  components: {
    Avatar
  },
  props: ["user", "userRole", "isActiveKioskModule", "showPhoto"],
  data() {
    return {
      isLoading: false,
      passwordSecure: true,
      form: {
        password: ""
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    }
  },
  validations: {
    form: {
      password: {
        required
      }
    }
  },
  computed: {
    ...mapGetters({
      activeSchool: "schools/activeSchool"
    }),
    isValid() {
      return !this.v$.form.$invalid
    }
  },
  methods: {
    togglePass() {
      this.passwordSecure = !this.passwordSecure
    },
    submit() {
      this.resetResponseMessages()
      if (this.isValid) {
        this.isLoading = true
        this.$store
          .dispatch("authentication/updateKioskPass", this.form.password)
          .then(() => {
            this.form.password = ""
            this.v$.$reset()
            this.setSuccessResponse("Successfully updated.")
            this.isLoading = false
            setTimeout(() => {
              this.resetResponseMessages()
            }, 1000)
          })
          .catch((err) => {
            this.isLoading = false
            // this.form.password = "";
            const response = err.response.data
            this.setErrorResponse(response.message, response.errors)
          })
      } else {
        this.v$.$touch()
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.kiosk-input-group {
  .field-icon {
    z-index: 1;
  }

  input {
    font-size: 16px;
    line-height: 20px;

    &::placeholder {
      font-size: 16px;
    }
  }
}
</style>
